<template>
    <a class="btn" :class="[$props.type, getHeight(), { 'disabled': $props.disabled }]" @click="$emit('click')">
        <svg v-if="loading" class="loader" xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
            <circle fill='#FF156D' stroke='#FF156D' stroke-width='15' r='15' cx='40' cy='100'>
                <animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;'
                    keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate>
            </circle>
            <circle fill='#FF156D' stroke='#FF156D' stroke-width='15' r='15' cx='100' cy='100'>
                <animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;'
                    keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate>
            </circle>
            <circle fill='#FF156D' stroke='#FF156D' stroke-width='15' r='15' cx='160' cy='100'>
                <animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;'
                    keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate>
            </circle>
        </svg>
        <slot v-else></slot>
    </a>
</template>

<script>
export default {
    name: "VButton",
    props: {
        type: { type: String, default: 'violet' },
        loading: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        height: { type: String, default: 'tall' }
    },
    methods: {
        getHeight() {
            return this.$props.height === 'short' ? 'btn-short' : 'btn-tall'
        },

    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

.btn {
    box-sizing: border-box;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    border: 2px solid;

    &>.loader {
        width: 70px;

        &>circle {
            fill: $color_white;
            stroke: $color_white;
        }
    }
}

.btn-tall {
    height: 68px;
}

.btn-short {
    height: 50px;
}

.violet {
    background-color: $color_blue_cornflower;
    color: $color_white;
    border-color: $color_blue_cornflower;
}

.dark-violet {
    background-color: $color_violet_electric;
    color: $color_white;
    border-color: $color_violet_electric;
}

.bordered {
    color: $color_blue_cornflower;
    border-color: $color_blue_cornflower;
}
</style>
